export const UPDATE_AVAILABLE_PAYMENT_METHODS = 'updateAvailablePaymentMethods';
export const SET_CAN_RETRY_SUBMIT = 'setCanRetrySubmit';
export const SET_HAS_VIRTUAL_INCENTIVE_ERRORS = 'setHasVirtualIncentivesErrors';
